export const FETCHING_PRYPOOL_PRODUCTS = "FETCHING.PRYPOOL_PRODUCTS";
export const FETCHING_SHARING_BOX = "FETCHING.SHARING_BOX";
export const FETCHING_SESSION_ID = "FETCHING.SESSION_ID";

export const FETCHED_PRYPOOL_PRODUCTS = "FETCHED.PRYPOOL_PRODUCTS";
export const FETCHED_SHARING_BOX = "FETCHED.SHARING_BOX";
export const FETCHED_SESSION_ID = "FETCHED.SESSION_ID";

export const ERROR_FETCHING_PRYPOOL_PRODUCTS = "ERROR.FETCHING_PRYPOOL_PRODUCTS";
export const ERROR_FETCHING_SHARING_BOX = "ERROR.FETCHING_SHARING_BOX";
export const ERROR_FETCHING_SESSION_ID = "ERROR.FETCHING_SESSION_ID";

export const PUSH_PRYPOOL_SELECTED_PRODUCT = "PUSH.PRYPOOL_SELECTED_PRODUCT";
export const REMOVE_PRYPOOL_SELECTED_PRODUCT = "REMOVE.PRYPOOL_SELECTED_PRODUCT";